import { render, staticRenderFns } from "./Contributor.vue?vue&type=template&id=8a720cb6&"
import script from "./Contributor.vue?vue&type=script&lang=ts&"
export * from "./Contributor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports